import {
    FETCH_LOCALES,
} from '../types';
import api from '../api';

export const fetchLocales = (ns, chainId, branchId, onSuccess) => {
    return {
        type: FETCH_LOCALES,
        payload: api.locales.get(ns, chainId, branchId),
        meta: { onSuccess }
    };
};

export const updateLocales = (ns, chainId, branchId, updates, onSuccess) => {
    return {
        type: FETCH_LOCALES,
        payload: api.locales.update(ns, chainId, branchId, updates),
        meta: { onSuccess }
    };
};

export const createLocale = (ns, row, onSuccess) => {
    return {
        type: FETCH_LOCALES,
        payload: api.locales.create(ns, row),
        meta: { onSuccess }
    };
};
